import React from 'react';

export const Header = (props) => {
  return (
    <div className={"container--header"}>
      <h1>Soccer Live Mobile</h1>
      <p>A mobile Control Application designed for soccer, right at your fingertips</p>
    </div>
  );
};

export default Header;